import React from "react";
import { useSelector } from "react-redux";
import orderReady from "../../../../assets/icons/orderReady.svg";
import inTransit from "../../../../assets/icons/inTransit.svg";
import outForDelivery from "../../../../assets/icons/outForDelivery.svg";
import delivered from "../../../../assets/icons/delivered.svg";
import custom_1 from "../../../../assets/images/custom_1.svg";
import custom_2 from "../../../../assets/images/custom_2.svg";
import custom_3 from "../../../../assets/images/custom_3.svg";
import custom_4 from "../../../../assets/images/custom_4.svg";
import custom_5 from "../../../../assets/images/custom_5.svg";
import moment from "moment";
import ProgressBarMobile from "../../../ProgressBarMobile";
import Ordered from "../../../SVGS/Ordered";

const ProgressBar = ({ order }) => {
  const customStatusIcons = [custom_1, custom_2, custom_3, custom_4, custom_5];
  const date = Date.now();
  const {
    tracking_summary,
    tracking_manual,
    created_at,
    tracking_detail: logs,
  } = order;
  const trackingDetails = typeof logs === "string" ? JSON.parse(logs) : logs;
  const trackingLogs = trackingDetails?.filter(
    ({ message, date_time }) => message?.length || date_time?.length
  );
  const {
    trackingStatus: i18n,
    customStatus,
    displayStatusBar,
    general: generalSettings,
  } = useSelector((state) => state.settings);
  const trackingStatus =
    tracking_summary === "courier_not_supported"
      ? tracking_manual ?? tracking_summary
      : tracking_summary;

  const listStatus = {
    courier_not_supported: 0,
    information_received: 2,
    pending: 1,
    in_transit: 3,
    failed_attempt: 4,
    exception: 4,
    expired: 4,
    out_for_delivery: 4,
    delivered: 5,
  };

  const activeIndex = listStatus[trackingStatus] ?? null;

  const isActiveCustomStatus =
    Math.abs(moment(created_at).diff(moment(), "days")) >=
    +customStatus.timeActive;

  return !displayStatusBar.length ? (
    ""
  ) : (
    <>
      <div className="omg-special-progress-bar mb-5">
        {activeIndex !== 0 && (
          <div
            className="stepper-wrapper"
            style={{ zIndex: "0", position: "relative", overflow: "hidden" }}
          >
            {displayStatusBar.find((item) => item === "Ordered") && (
              <div
                className={`stepper-item ${activeIndex !== 0 && "completed"}`}
              >
                {/* <img alt="..." src={`${ordered}?v=${date}`} /> */}
                <Ordered />
                <div className="step-counter-icon">
                  <div className="step-counter">1</div>
                  <div className="step-name">{i18n.ordered}</div>
                  <div className="omg-time__minor">
                    {moment(created_at).format(generalSettings.dateFormat)}
                  </div>
                </div>
              </div>
            )}{" "}
            {(customStatus?.enabled === 1 ||
              customStatus?.enabled === true) && (
              <div
                className={`stepper-item ${
                  isActiveCustomStatus || activeIndex ? "completed" : ""
                }`}
              >
                {customStatus.icon > 0 ? (
                  <img
                    alt="..."
                    src={`${
                      customStatusIcons[customStatus.icon - 1]
                    }?v=${date}`}
                    width={40}
                    height={40}
                  />
                ) : (
                  <div style={{ width: "40px", height: "57px" }} />
                )}
                <div className="step-counter-icon">
                  <div className="step-counter">1.5</div>
                  <div className="step-name">{customStatus.label}</div>
                  <div className="omg-time">
                    <div className="omg-time__minor">
                      {moment(created_at)
                        .add(customStatus.timeActive, "days")
                        .format(generalSettings.dateFormat)}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {trackingStatus === "pending" &&
              displayStatusBar.find((item) => item === "Ordered") && (
                <div
                  className="completed stepper-pending position-absolute"
                  style={
                    customStatus?.enabled == 1 || customStatus?.enabled == true
                      ? { left: "30%" }
                      : { left: "17%" }
                  }
                >
                  <div className="step-name">{i18n.pending}</div>
                </div>
              )}
            {displayStatusBar.find((item) => item === "Order Ready") && (
              <div
                className={`stepper-item ${activeIndex >= 2 && "completed"}`}
              >
                <img
                  alt="..."
                  src={`${orderReady}?v=${date}`}
                  type="image/svg+xml"
                />
                <div className="step-counter-icon">
                  <div className="step-counter">2</div>
                  <div className="step-name">{i18n.information_received}</div>
                  {activeIndex >= 1 &&
                  trackingLogs &&
                  trackingLogs[trackingLogs?.length - 1] ? (
                    <div className="omg-time">
                      <div className="omg-time__minor">
                        {moment(
                          trackingLogs[trackingLogs.length - 1].date_time
                        ).format(generalSettings.dateFormat)}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}{" "}
            {/* <div className={`stepper-item ${activeIndex >= 2 && "completed"}`}>
            <img alt="..." src={available} />
            <div className="step-counter-icon">
              <div className="step-counter">3</div>
              <div className="step-name">{i18n.available_for_pickup}</div>
            </div>
          </div> */}
            {displayStatusBar.find((item) => item === "In transit") && (
              <div
                className={`stepper-item ${activeIndex >= 3 && "completed"}`}
              >
                <img alt="..." src={`${inTransit}?v=${date}`} />
                <div className="step-counter-icon">
                  <div className="step-counter">3</div>
                  <div className="step-name">{i18n.in_transit}</div>
                  {activeIndex >= 3 &&
                  trackingLogs &&
                  trackingLogs[trackingLogs.length - 2] ? (
                    <div className="omg-time">
                      <div className="omg-time__minor">
                        {moment(
                          trackingLogs[trackingLogs.length - 2].date_time
                        ).format(generalSettings.dateFormat)}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
            {displayStatusBar.find((item) => item === "Out for delivery") && (
              <div
                className={`stepper-item ${activeIndex >= 4 && "completed"}`}
              >
                <img
                  alt="..."
                  src={`${outForDelivery}?v=${date}`}
                  type="image/svg+xml"
                />
                <div className="step-counter-icon">
                  <div className="step-counter">4</div>
                  <div className="step-name">{i18n.out_for_delivery}</div>
                  {activeIndex >= 4 && trackingLogs[1] ? (
                    <div className="omg-time">
                      <div className="omg-time__minor">
                        {moment(trackingLogs[1].date_time).format(
                          generalSettings.dateFormat
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}{" "}
            {displayStatusBar.find((item) => item === "Delivered") && (
              <div
                className={`stepper-item ${activeIndex >= 5 && "completed"}`}
              >
                <img alt="..." src={`${delivered}?v=${date}`} />
                <div className="step-counter-icon">
                  <div className="step-counter">5</div>
                  <div className="step-name">{i18n.delivered}</div>
                  {activeIndex >= listStatus.delivered && trackingLogs?.length && (
                    <div className="omg-time">
                      <div className="omg-time__minor">
                        {moment(trackingLogs[0].date_time).format(
                          generalSettings.dateFormat
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}{" "}
          </div>
        )}
      </div>
      <ProgressBarMobile
        src={customStatusIcons[customStatus.icon - 1]}
        order={order}
      />
    </>
  );
};

export default ProgressBar;
